import { useQuery } from '@tanstack/react-query'
import { fetchOutstandingReports, fetchPeriodStatistics } from '../services/statistics'

export function useStatistics(dateFrom: string, dateTo: string) {
  return useQuery({
    queryKey: ['statistics', dateFrom, dateTo],
    queryFn: () => fetchPeriodStatistics(dateFrom, dateTo),
    staleTime: 2 * 60 * 1000,
  })
}

export function useOutstandingReports() {
  return useQuery({
    queryKey: ['outstanding-reports'],
    queryFn: fetchOutstandingReports,
    staleTime: 60 * 1000,
  })
}
